import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-center mb-6">
        Refund Policy - Ducktail
      </h1>
      <div className="max-w-2xl mx-auto">
        <p className="text-lg text-gray-700">
          Once the resignation is done and amount is paid there is no refund.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
